import { useAtom } from 'jotai';
import React from 'react';
import { selectedDepartmentAtom } from '../../../shared/selected.department';
import { turnModeAtom } from '../../../shared/turn.mode';
import { isPreviouslySelectedTurnModeAtFirstPage } from '../../../functions/isPreviouslySelectedTurnModeAtFirstPage';
import { isThirdPageAndPreviouslySelected } from '../../../functions/isThirdPageAndPreviouslySelected';
import { SelectType } from '../../../functions/SelectType';
import { selectedTurnBase } from '../../../shared/selected.turn.base';
import { isOneTermItemPresent } from '../../../functions/isOneTermItemPresent';
import { isForthPageAndOneItem } from '../../../functions/isForthPageAndOneItem';
import { selectedTurnItem } from '../../../shared/selected.turn.items';
import { isPageThreeAndOneDoctor } from '../../../functions/isPageThreeAndOneDoctor';
import { isFifthPageAndOneDoctor } from '../../../functions/isFifthPageAndOneDoctor';
import { GetNobatPrefrences } from 'utils/GetNobatPrefrences';
import { isNearestTurnDisabled } from '../../../functions/isNearestTurnDisabled';
import { isSixthPageAndNoNearestTurn } from '../../../functions/isSixthPageAndNoNearestTurn';
import { isThirdPageAndNoNearestTurn } from '../../../functions/isThirdPageAndNoNearestTurn';
import { isSixthPageAndOneDoctor } from '../../../functions/isSixthPageAndOneDoctor';
import { isSecondPageAndCenter } from '../../../functions/isSecondPageAndCenter';
import { isPageTwoAndOneDoctor } from '../../../functions/isPageTwoAndOneDoctor';
import { selectedDoctorAtom } from 'Routes/Public/GetNewTurn/shared/selected.doctor';
import { selectedSpecialityServiceAtom } from 'Routes/Public/GetNewTurn/shared/selected.speciality.service';
import { seletedDepartmentId } from 'Routes/Public/GetNewTurn/shared/selected.department.ids';
import { nearestTurnAtom } from 'Routes/Public/GetNewTurn/shared/nearest.turn';

const useHandleBlLogic = (
  steps,
  setSteps,
  turnBaseData,
  doctors,
  specialityService,
  departments,
  pageConfig
) => {
  const [department, setSelectedDepartment] = useAtom(
    selectedDepartmentAtom
  );

  const turn_configs = JSON.parse(
    localStorage.getItem('nobat_prefrence')
  );
  const main_turn_config = Number(
    turn_configs?.filter(
      (fl) => fl.Key === 'webAppnoeEntekhabeNobatPatient'
    )[0]?.Value
  );

  const [, setTurnMode] = useAtom(turnModeAtom);

  const [turnBase, setTurnBase] = useAtom(selectedTurnBase);

  const [, setSelectedTurnItem] = useAtom(selectedTurnItem);

  const noeEntekhab = SelectType();

  const prefrences = GetNobatPrefrences();

  const [nearestTurn] = useAtom(nearestTurnAtom);

  const isFastNobat = nearestTurn?(nearestTurn.nobatInfo?
    turnBase === 'speciality'
      ? false
      : prefrences
      ? prefrences?.filter(
          (prefrence) =>
            prefrence.Key === 'webAppgetFastNobat'
        )[0]?.Value === 'True'
      : null:false):false;

  const [selectedDoctor, setSelectedDoctor] = useAtom(
    selectedDoctorAtom
  );

  const [, setSelectedSpecialityService] = useAtom(
    selectedSpecialityServiceAtom
  );

  const [departmentIds] = useAtom(seletedDepartmentId);

  


  // console.log('-->', {
  //   steps,
  //   setSteps,
  //   turnBaseData,
  //   doctors,
  //   turnBase,
  //   department,
  //   isFastNobat,
  //   specialityService,
  //   selectedDoctor,
  //   departments,
  // });

  // console.log('isFastNobat isFastNobat isFastNobat =>',{isFastNobat,nearestTurn})

  // console.log('-->', {
  //   steps,
  //   doctors,
  //   isFastNobat,
  //   department,
  // });

  console.log('-->', {
    steps,
    setSteps,
    turnBaseData,
    doctors,
    turnBase,
    department,
    isFastNobat,
    specialityService,
    selectedDoctor,
    departments,
  });

  // const pageConfig = {
  //   pageConfig: {
  //     noeEntekhabeNobatPatient: 2,
  //   },
  // };

  const HandleForward = () => {
    if (steps === 0 && doctors) {
      if (isFastNobat) {
        setSteps(4);
        return;
      }
      if (doctors?.length === 1) {
        setSelectedDoctor(doctors[0]);
        if (turnBase !== 'speciality') {
          setSteps(7);
          return;
        }
        if (
          steps === 5 &&
          turnBase === 'speciality' &&
          specialityService?.length === 1
        ) {
          setSelectedSpecialityService(
            specialityService[0]
          );
          setSteps((prev) => prev + 2);
          return;
        }
      }
      setSteps(5);
      return;
    }

    if (
      main_turn_config === 1 &&
      steps !== 3 &&
      steps !== 5
    ) {
      setTurnBase('service');
      if (departments?.length === 1) {
        setSelectedDepartment(departments[0]);
        if (steps !== 4 || !isFastNobat) {
          setSteps((prev) => prev + 3);
          return;
        }
      }
    }

    if (steps === 1 && department) {
      if (
        turnBase === 'service' &&
        turnBaseData?.serviceBased?.length === 1
      ) {
        setSteps((prev) => prev + 3);
        return;
      }
      if (
        turnBase === 'speciality' &&
        turnBaseData?.specialityBased?.length === 1
      ) {
        setSteps((prev) => prev + 3);
        return;
      }
    }

    if (
      main_turn_config === 2 &&
      steps !== 3 &&
      steps !== 5
    ) {
      setTurnBase('speciality');
      if (departments?.length === 1) {
        setSelectedDepartment(departments[0]);
        setSteps((prev) => prev + 3);
        return;
      }
    }

    if (steps === 0 && departments?.length === 1) {
      setSelectedDepartment(departments[0]);
      setSteps((prev) => prev + 2);
      return;
    }
    if (isSecondPageAndCenter(steps, doctors, department)) {
      if (doctors?.length === 1) {
        setSelectedDoctor(departmentIds[0]);
      }

      if (!isFastNobat && doctors?.length === 1) {
        setSteps((prev) => prev + 5);
        return;
      } else {
        setSteps((prev) => prev + 3);
        return;
      }
    }

    if (steps === 1 && main_turn_config === 1) {
      setTurnBase('service');
      setSteps((prev) => prev + 2);
      return;
    }
    if (steps === 1 && main_turn_config === 2) {
      setTurnBase('speciality');
      setSteps((prev) => prev + 2);
      return;
    }

    if (
      steps === 1 &&
      department?.NobatBaPezeshKYaVahed === 2 &&
      turnBaseData?.serviceBased?.length === 1
    ) {
      setTurnBase('service');
      setSelectedTurnItem(turnBaseData.serviceBased[0]);
      if (!isFastNobat) {
        if (doctors?.length === 1) {
          setSteps((prev) => prev + 5);
        } else {
          setSteps((prev) => prev + 4);
        }
        return;
      }

      setSteps((prev) => prev + 3);
      return;
    }
    if (
      steps === 1 &&
      department.NobatBaPezeshKYaVahed === 2
    ) {
      setSteps((prev) => prev + 1);
      return;
    }

    if (
      isPreviouslySelectedTurnModeAtFirstPage(
        noeEntekhab,
        department,
        steps
      )
    ) {
      setSteps((prev) => prev + 2);
    }

    if (
      isOneTermItemPresent(
        noeEntekhab,
        turnBase,
        steps,
        turnBaseData
      )
    ) {
      if (turnBase === 'service') {
        setSelectedTurnItem(turnBaseData.serviceBased[0]);
      }
      if (turnBase === 'speciality') {
        setSelectedTurnItem(
          turnBaseData.specialityBased[0]
        );
      }
      if (isPageTwoAndOneDoctor(steps, doctors)) {
        setSelectedDoctor(doctors[0]);
        if (!isFastNobat) {
          setSteps((prev) => prev + 3);
          return;
        }

        setSteps((prev) => prev + 4);
        return;
      }
      if (!isFastNobat) {
        setSteps((prev) => prev + 4);
        return;
      }
      setSteps((prev) => prev + 2);
      return;
    }

    if (
      steps === 3 &&
      turnBase === 'speciality' &&
      specialityService?.length === 1
    ) {
      if (doctors?.length === 1) {
        setSelectedDoctor(doctors[0]);

        if (specialityService?.length === 1) {
          setSelectedSpecialityService(
            specialityService[0]
          );
        }

        if (isFastNobat) {
          setSteps((prev) => prev + 1);
          return;
        }
        setSteps((prev) => prev + 4);
        return;
      }
      setSteps((prev) => prev + 2);
      return;
    }

    if (isPageThreeAndOneDoctor(steps, doctors)) {
      if (doctors?.length === 1) {
        setSelectedDoctor(doctors[0]);
      }
      if (!isFastNobat) {
        setSteps((prev) => prev + 4);
        return;
      }

      setSteps((prev) => prev + 1);
      return;
    }

    if (steps === 3 && doctors?.length > 1) {
      if (!isFastNobat) {
        setSteps((prev) => prev + 2);
        return;
      }
    }

    if (
      steps === 4 &&
      doctors?.length === 1 &&
      turnBase === 'speciality'
    ) {
      setSelectedDoctor(doctors[0]);
      if (specialityService?.length === 1) {
        setSteps((prev) => prev + 3);
        return;
      }
      setSteps((prev) => prev + 2);
      return;
    }
    if (steps === 4 && doctors?.length === 1) {
      setSelectedDoctor(doctors[0]);
      setSteps((prev) => prev + 3);
      return;
    }

    if (
      steps === 5 &&
      turnBase === 'speciality' &&
      specialityService?.length === 1
    ) {
      setSelectedSpecialityService(specialityService[0]);
      setSteps((prev) => prev + 2);
      return;
    }
    if (steps === 5 && turnBase !== 'speciality') {
      setSteps((prev) => prev + 2);
      return;
    }

    // if (isNearestTurnDisabled(steps, isFastNobat)) {
    //   setSteps((prev) => prev + 2);
    //   return;
    // }

    // if (isThirdPageAndNoNearestTurn(steps, isFastNobat)) {
    //   setSteps((prev) => prev + 3);
    //   return;
    // }

    setSteps((prev) => prev + 1);
  };

  const HandleBackward = () => {
    if (steps <= 7) {
      if (steps === 2 && departments?.length === 1) {
        setSteps((prev) => prev - 2);
        return;
      }

      if (steps === 3 && main_turn_config !== 3) {
        if (departments?.length === 1) {
          setSteps((prev) => prev - 3);
          return;
        }

        setSteps((prev) => prev - 2);
        return;
      }

      if (steps !== 0 && steps > 0) {
        if (
          isThirdPageAndPreviouslySelected(
            noeEntekhab,
            department,
            steps
          )
        ) {
          if (departments?.length === 1) {
            setSteps((prev) => prev - 3);
            setTurnMode(null);
            return;
          }
          setSteps((prev) => prev - 2);
          setTurnMode(null);
          return;
        }

        if (steps === 4 && department && !doctors) {
          if (
            turnBase === 'service' &&
            turnBaseData?.serviceBased?.length === 1
          ) {
            setSteps((prev) => prev - 3);
            return;
          }
          if (
            turnBase === 'speciality' &&
            turnBaseData?.specialityBased?.length === 1
          ) {
            setSteps((prev) => prev - 3);
            return;
          }
        }

        if (steps === 4) {
          if (
            turnBase === 'service' &&
            main_turn_config === 1 &&
            turnBaseData?.serviceBased?.length === 1
          ) {
            if (departments?.length > 1) {
              setSteps((prev) => prev - 2);
              return;
            }

            setSteps((prev) => prev - 4);
            return;
          }
          if (
            turnBase === 'speciality' &&
            main_turn_config === 2 &&
            turnBaseData?.specialityBased?.length === 1
          ) {
            if (departments?.length > 1) {
              setSteps((prev) => prev - 2);
              return;
            }

            setSteps((prev) => prev - 4);
            return;
          }
        }

        if (
          steps === 4 &&
          department?.NobatBaPezeshKYaVahed === 2 &&
          turnBaseData?.serviceBased?.length === 1
        ) {
          if (departments?.length === 1) {
            setSteps((prev) => prev - 4);
            return;
          }

          setSteps((prev) => prev - 3);
          return;
        }

        if (
          isForthPageAndOneItem(
            noeEntekhab,
            turnBase,
            steps,
            turnBaseData
          )
        ) {
          setSteps((prev) => prev - 2);
          return;
        }

        if (isFifthPageAndOneDoctor(steps, doctors)) {
          setSteps((prev) => prev - 2);
          return;
        }

        if (isSixthPageAndOneDoctor(steps, doctors)) {
          if (!isFastNobat) {
            if (
              turnBaseData?.serviceBased?.length === 1 ||
              turnBaseData?.specialityBased?.length === 1
            ) {
              if (departments?.length !== 1) {
                setSteps((prev) => prev - 6);
                return;
              }

              if (
                turnBase === 'speciality' ||
                turnBase === 'service'
              ) {
                if (
                  turnBaseData?.serviceBased?.length ===
                    1 ||
                  turnBaseData?.specialityBased?.length ===
                    1
                ) {
                  setSteps((prev) => prev - 7);
                  return;
                }
                setSteps((prev) => prev - 4);
                return;
              }

              setSteps((prev) => prev - 5);
              return;
            }
            if (department?.NobatBaPezeshKYaVahed !== 2) {
              setSteps((prev) => prev - 4);
              return;
            } else {
              if (departments?.length !== 1) {
                setSteps((prev) => prev - 6);
                return;
              }
              if (
                turnBase === 'speciality' ||
                turnBase === 'service'
              ) {
                setSteps((prev) => prev - 4);
                return;
              }
              setSteps((prev) => prev - 5);
              return;
            }
          }

          setSteps((prev) => prev - 3);
          return;
        }
        if (
          steps === 7 &&
          turnBase === 'speciality' &&
          specialityService?.length === 1
        ) {
          setSteps((prev) => prev - 2);
          return;
        }

        if (steps === 7 && turnBase !== 'speciality') {
          setSteps((prev) => prev - 2);
          return;
        }

        if (
          isSixthPageAndNoNearestTurn(steps, isFastNobat)
        ) {
          setSteps((prev) => prev - 1);
          return;
        }

        if (steps === 5 && !isFastNobat) {
          if (main_turn_config !== 3) {
            if (
              (turnBase === 'speciality' &&
                turnBaseData?.specialityBased?.length >
                  1) ||
              (turnBase === 'service' &&
                turnBaseData?.serviceBased?.length > 1)
            ) {
              setSteps((prev) => prev - 2);
              return;
            }
            if (departments?.length === 1) {
              setSteps((prev) => prev - 5);
              return;
            }
            setSteps((prev) => prev - 4);
            return;
          }

          setSteps((prev) => prev - 3);
          return;
        }

        setSteps((prev) => prev - 1);
      }
    }
  };

  return [HandleForward, HandleBackward];
};

export default useHandleBlLogic;
